export function checkIsTruncated(e: HTMLParagraphElement | null) {
  if (!e) return false;
  return e.offsetWidth < e.scrollWidth || e.offsetHeight < e.scrollHeight;
}
